/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Road_Dude_Hero_KickerInputs */

const en_road_dude_hero_kicker = /** @type {(inputs: Road_Dude_Hero_KickerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`THE STATE PROPERTY MEME`)
};

const zh_road_dude_hero_kicker = /** @type {(inputs: Road_Dude_Hero_KickerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`STATE PROPERTY · 私人领地梗`)
};

/**
* | output |
* | --- |
* | "THE STATE PROPERTY MEME" |
*
* @param {Road_Dude_Hero_KickerInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const road_dude_hero_kicker = /** @type {((inputs?: Road_Dude_Hero_KickerInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Road_Dude_Hero_KickerInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_road_dude_hero_kicker(inputs)
	return zh_road_dude_hero_kicker(inputs)
});
export { road_dude_hero_kicker as "road_dude.hero.kicker" }